import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'stock-alerts',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `stock-alerts`,
    method: 'get',
    params: queriesParams
  })
}

export function show (id) {
  return request({
    url: `stock-alert/${id}`,
    method: 'get'
  })
}

export function add (data) {
  return request({
    url: 'stock-alert',
    method: 'post',
    data
  })
}

export function edit (id, data) {
  return request({
    url: `stock-alert/${id}`,
    method: 'patch',
    data
  })
}

export function suspendEmail (id, data) {
  return request({
    url: `suspend-send-email/${id}`,
    method: 'patch',
    data
  })
}
